module.exports = __webpack_public_path__ + "img/T2C_rc_8.88178fff.png";